export enum ModalStatusTransitionTriggersEnums {
	INACTIVE = 'inactive',
	CONFIRMATION = 'confirmation',
	TRIGGER_PAYLOAD = 'triggerPayload',
	INVOICE_BATCH = 'invoiceBatch'
}
